import React from 'react';
import { Form, message, Button, Input } from 'antd';
import { useAuth } from '../commons/contexts/auth-context';
import { useLocation } from 'react-router-dom';

function ResetPassword(props) {
  const { form } = props;
  const { resetPassword } = useAuth();
  const urlString = useLocation();

  function sendNewPass(e) {
    e.preventDefault();

    form.validateFields(async (err, values) => {
      if (!err) {
        try {
          const token = urlString.search.replace('?t=', '');
          console.log(token);

          if (token === '') {
            return message.error(
              'Invalid Link. Please check your email for valid link'
            );
          }
          //console.log(values.password);
          const filteredValue = values.password.trim();
          //console.log(filteredValue);
          if (filteredValue === '') {
            return message.error("Password can't be empty");
          }
          let body = {
            newPass: filteredValue,
            resetToken: token,
          };
          let res = await resetPassword(body);
          message.success(`${res.message}`);
          form.resetFields();
          setTimeout(() => {
            window.location = '/login';
          }, 2000);
        } catch (e) {
          message.error(`${e.message}`);
        }
      }
    });
  }

  return (
    <Form onSubmit={sendNewPass} className="password-form">
      <h2>Reset Password</h2>
      <p>Please enter a new password </p>
      <Form.Item className="alt-left" label="New Password">
        {form.getFieldDecorator('password', {
          rules: [{ required: true, message: 'Please input your Password' }],
        })(<Input.Password />)}
      </Form.Item>
      <Button type="primary" htmlType="submit" className="login-form-button">
        Reset
      </Button>
    </Form>
  );
}
export default Form.create({ name: 'reset_password' })(ResetPassword);
